enum SizeEnum {
    mini = 'mini',
    small = 'small',
    //中等
    medium = 'medium',
    //巨大
    large = 'large',

}

enum IconEnum {
    audio = "audio.png",
    excel = "excel.png",
    pdf = "pdf.png",
    pic = "pic.png",
    ppt = "ppt.png",
    zip = "rarzip.png",
    txt = "txt.png",
    unknown = "unkown.png",
    video = "video.png",
    word = "word.png",
}

enum RTCUserMark {
    teacher = "T_",
    student = "S_",
    notLoggedIn = 'X_'
}

enum UserType {
    teacher = "T",
    student = "S",
    notLoggedIn = 'X'

}

/**
 * 用户在线状态枚举类
 */
enum UserOnlineStatus {
    // 在线
    online = 'online',
    // 离线
    offline = 'offline'
}

export {SizeEnum, IconEnum,UserType, RTCUserMark, UserOnlineStatus};
